import 'whatwg-fetch';
import StorageService from 'services/StorageService/';
import PubSub from 'services/PubSub/';
import CartAction from 'actions/Cart';
import { api } from 'config';

const getUser = () => {

    let token = StorageService.getItem('sessionData');

    return fetch(api.user + `/user/`, {
        method: 'GET',
        headers: {
            'x-api-key': api.apiKey,
            'token': token,
            'Content-Type': 'application/json'
        }
    }).then(results => results.json())
        .then(results => {
            if (results && results.status === 401) {
                CartAction.logout(()=> {CartAction.logoutRedirect()});
            }
            return results;
        })
        .catch(() => {
            PubSub.dispatch('error_503');
            return false
        });
}


const _updateUser = (body) => {
    const token = StorageService.getItem('sessionData');

    return fetch(api.user + `/user/`, {
        method: 'PUT',
        headers: {
            'x-api-key': api.apiKey,
            'token': token,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body),
    }).then(results => results.json())
        .catch(() => {
            PubSub.dispatch('error_503');
            return false
        });
};

const updateUser = (userInfo) => {
    const userData = StorageService.getSecureItem('userData');

    return _updateUser({
        "firstName": userInfo.firstName,
        "lastName": userInfo.lastName,
        "document": userInfo.document,
        "homePhone": userInfo.homePhone,
        "birthDate": userInfo.birthDate,
        "gender": userInfo.gender,
        "email": userData.email,
        "tel_update": userInfo.tel_update,
        "tel_update_date": userInfo.tel_update_date,
        "isNewsletterOptIn": userInfo.isNewsletterOptIn,
        "terms_acceptance_date": userInfo.terms_acceptance_date
    });
};

const updtePersistentCart = (data) => {
    return _updateUser(data);
};


const isEmployee = ()=> {
    const userData = StorageService.getSecureItem('userData');

    return (userData && userData.xIsEmployee);
}

const UserInfoService = {
    getUser,
    updateUser,
    updtePersistentCart,
    isEmployee
}

export default UserInfoService;
